"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireWildcard(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _Box = _interopRequireDefault(require("../Containers/Box"));
var _Notifications2 = _interopRequireDefault(require("./header/Notifications"));
var _Realm2 = _interopRequireDefault(require("./header/Realm"));
var _TimezoneSwitcher2 = _interopRequireDefault(require("./header/TimezoneSwitcher"));
var _User2 = _interopRequireDefault(require("./header/User"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var propTypes = {
  /** This function allow rendering on the right
   side of the header. */
  renderRight: _propTypes["default"].func,
  /** String used for automation. Will be used with suffixes for each header component */
  automationHook: _propTypes["default"].string
};
var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "Header__Wrapper",
  componentId: "sc-dwji1u-0"
})(["display:flex;width:100%;justify-content:space-between;padding:0 ", ";gap:", ";"], function (props) {
  return props.theme.layouts.p;
}, function (props) {
  return props.theme.spaces.base;
});
var PageTitleContainer = _styledComponents["default"].div.withConfig({
  displayName: "Header__PageTitleContainer",
  componentId: "sc-dwji1u-1"
})(["display:flex;align-items:center;"]);
var Header = function Header(_ref) {
  var renderRight = _ref.renderRight,
    _ref$automationHook = _ref.automationHook,
    automationHook = _ref$automationHook === void 0 ? "header" : _ref$automationHook;
  var renderHeaderChildren = (0, _react.useCallback)(function () {
    return renderRight === null || renderRight === void 0 ? void 0 : renderRight({
      TimezoneSwitcher: function TimezoneSwitcher(props) {
        return /*#__PURE__*/_react["default"].createElement(_TimezoneSwitcher2["default"], _extends({
          automationHook: (0, _automationHooks.getHook)(automationHook, "timezone")
        }, props));
      },
      User: function User(props) {
        return /*#__PURE__*/_react["default"].createElement(_User2["default"], _extends({
          automationHook: (0, _automationHooks.getHook)(automationHook, "user")
        }, props));
      },
      Realm: function Realm(props) {
        return /*#__PURE__*/_react["default"].createElement(_Realm2["default"], _extends({
          automationHook: (0, _automationHooks.getHook)(automationHook, "realms")
        }, props));
      },
      Notifications: function Notifications(props) {
        return /*#__PURE__*/_react["default"].createElement(_Notifications2["default"], _extends({
          automationHook: (0, _automationHooks.getHook)(automationHook, "notifications")
        }, props));
      }
    });
  }, [renderRight, automationHook]);
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(PageTitleContainer, {
    id: "header-portal",
    automationHook: (0, _automationHooks.getHook)(automationHook, "title")
  }), /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    d: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "base",
    wrap: "wrap"
  }, renderHeaderChildren()));
};
Header.propTypes = propTypes;
var _default = Header;
exports["default"] = _default;